/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import { useEffect } from "react";
import PropTypes from "prop-types";

import { usePlayer } from "./hooks";

export default function Video({ options, onDisplayClick }) {
  const player = usePlayer();
  const { source, disabled = false } = options;

  useEffect(() => {
    player.load(source);
  }, [source, player]);

  useEffect(() => {
    let unsubscribe = () => {};
    if (player && player.onDisplayClick) {
      unsubscribe = player.onDisplayClick(onDisplayClick);
    }
    return () => {
      unsubscribe();
    };
  }, [onDisplayClick, player]);

  return (
    <div className="relative">
      <div ref={player.containerRef} />
      <div
        onClick={onDisplayClick}
        className={
          disabled === true
            ? "absolute inset-0 overflow-hidden cursor-pointer"
            : "hidden"
        }
        data-testid="playAttemptBtn"
      />
    </div>
  );
}

Video.propTypes = {
  options: PropTypes.shape({
    source: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
  }).isRequired,
  onDisplayClick: PropTypes.func,
};

Video.defaultProps = {
  onDisplayClick: () => {},
};
